import { render, staticRenderFns } from "./ForPool2.vue?vue&type=template&id=6b7b6b2f&scoped=true"
import script from "./ForPool2.vue?vue&type=script&lang=js"
export * from "./ForPool2.vue?vue&type=script&lang=js"
import style0 from "./ForPool2.vue?vue&type=style&index=0&id=6b7b6b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b6b2f",
  null
  
)

export default component.exports